import { HolderTableTradeCell } from './holder-table-trade-cell'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type HolderTableSoldCellProps = {
  sellVolumeInUsd: BigNumber
  sellVolumeInToken: BigNumber
  sells: number
} & ClassNameProps

export const HolderTableSoldCell = (props: HolderTableSoldCellProps) => {
  return (
    <HolderTableTradeCell
      color={'red'}
      volumeInUsd={props.sellVolumeInUsd}
      volumeInToken={props.sellVolumeInToken}
      number={props.sells}
    />
  )
}
